import React, { useEffect, FC } from "react";
import * as lottie from "lottie-web";

interface Props {
  animationData: any;
  speed?: number;
  loop?: boolean;
  autoplay?: boolean;
  startIndex?: number;
  onComplete?: () => void;
}

const Loader: FC<Props> = (props: Props) => {
  const {
    animationData,
    speed,
    loop,
    autoplay,
    startIndex,
    onComplete,
  } = props;

  let loaderWrapper: any = null;

  const assignRef = (image: any) => {
    loaderWrapper = image;
  };

  useEffect(() => {
    const animData = {
      wrapper: loaderWrapper,
      animType: "svg",
      loop: typeof loop !== "undefined" ? loop : true,
      prerender: true,
      autoplay: typeof autoplay !== "undefined" ? autoplay : true,
      animationData,
    };
    // @ts-ignore
    const anim = lottie.loadAnimation(animData);
    anim.addEventListener("complete", onComplete);
    anim.setSpeed(speed);

    anim.goToAndPlay(startIndex);

    return function cleanup() {
      anim.destroy();
    };
  }, [
    animationData,
    autoplay,
    loaderWrapper,
    loop,
    onComplete,
    speed,
    startIndex,
  ]);

  return <div ref={assignRef} id="loader" />;
};

Loader.defaultProps = {
  speed: 1,
  loop: undefined,
  autoplay: undefined,
  startIndex: 0,
  onComplete: () => {},
};

export default Loader;
try {
    // @ts-ignore
    Loader.displayName = "Loader";
    // @ts-ignore
    Loader.__docgenInfo = { "description": "", "displayName": "Loader", "props": { "animationData": { "defaultValue": null, "description": "", "name": "animationData", "required": true, "type": { "name": "any" } }, "speed": { "defaultValue": { value: 1 }, "description": "", "name": "speed", "required": false, "type": { "name": "number" } }, "loop": { "defaultValue": { value: "undefined" }, "description": "", "name": "loop", "required": false, "type": { "name": "boolean" } }, "autoplay": { "defaultValue": { value: "undefined" }, "description": "", "name": "autoplay", "required": false, "type": { "name": "boolean" } }, "startIndex": { "defaultValue": { value: 0 }, "description": "", "name": "startIndex", "required": false, "type": { "name": "number" } }, "onComplete": { "defaultValue": { value: "() => {}" }, "description": "", "name": "onComplete", "required": false, "type": { "name": "() => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Loading/Loader.tsx#Loader"] = { docgenInfo: Loader.__docgenInfo, name: "Loader", path: "src/shared/components/Loading/Loader.tsx#Loader" };
}
catch (__react_docgen_typescript_loader_error) { }